/**
 * 万能渲染默认模型 ID
 * 不区分 VIP / 非 VIP，统一使用此模型作为默认渲染风格
 * 对应接口：/api/model/detail
 *
 * 生产/灰度环境与测试环境的模型数据库不同，需按环境区分
 * 生产/灰度 ID 待确认后替换
 */
const isProdLike = ["production", "gray"].includes(import.meta.env.VITE_ENV);
export const DEFAULT_RENDER_MODEL_ID = isProdLike ? 46261 : 33357;
